import { TypedDocumentNode, gql } from '@apollo/client';

import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { withRouteQuery } from '@sorare/core/src/lib/navigation/withRouteQuery';

import { LastFixtureStory } from '@sorare/gameplay/src/components/so5/LastFixtureStory';

import { WithOnboardingComponents } from 'components/home/WithOnboardingComponents';
import { PlayPage as PlayPageComponent } from 'components/playPage/PlayPage';
import { UnclaimedDeliverableItemOrders } from 'components/rewards/UnclaimedDeliverableItemOrders';

import {
  FootballPlayQuery,
  FootballPlayQueryVariables,
} from './__generated__/page.graphql';

const FOOTBALL_PLAY_QUERY = gql`
  query FootballPlayQuery($sport: Sport!) {
    config {
      id
      ...PlayPage_config
    }
    so5 {
      id
      myAvailableFixtureStory(sport: $sport) {
        id
        ...LastFixtureStory_story
      }
      ...PlayPage_so5Root
    }
    football {
      id
      ...PlayPage_footballRoot
    }
    tokens {
      ...PlayPage_TokenRoot
    }
    currentUser {
      slug
      ...PlayPage_currentUser
      ...WithOnboardingComponents_currentUser
    }
  }
  ${PlayPageComponent.fragments.config}
  ${PlayPageComponent.fragments.TokenRoot}
  ${PlayPageComponent.fragments.footballRoot}
  ${LastFixtureStory.fragments.story}
  ${PlayPageComponent.fragments.so5Root}
  ${PlayPageComponent.fragments.currentUser}
  ${WithOnboardingComponents.fragments.currentUser}
` as TypedDocumentNode<FootballPlayQuery, FootballPlayQueryVariables>;

const PlayPage = withRouteQuery(
  ({ queryResult }) => {
    const { data } = queryResult;
    const { config, so5, football, currentUser, tokens } = data;

    return (
      <WithOnboardingComponents currentUser={currentUser}>
        <PlayPageComponent
          config={config}
          footballRoot={football}
          so5Root={so5}
          tokenRoot={tokens}
          currentUser={currentUser}
        >
          <LastFixtureStory story={so5.myAvailableFixtureStory} />
          <UnclaimedDeliverableItemOrders />
        </PlayPageComponent>
      </WithOnboardingComponents>
    );
  },
  {
    query: FOOTBALL_PLAY_QUERY,
    queryOptions: () => ({
      variables: {
        sport: Sport.FOOTBALL,
      },
    }),
  }
);

export default PlayPage;
